import { alpha } from '@mui/material'

const styles = {
  root: {
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
    zIndex: theme => theme.zIndex.drawer,
    backgroundColor: 'neutral.white',
  },
  header: {
    position: 'sticky',
    top: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pt: 3,
    px: 2,
    pb: 5,
    background: theme =>
      `linear-gradient(${theme.palette.neutral.white} 50%, ${alpha(
        theme.palette.neutral.white,
        0,
      )} 100%)`,
    zIndex: 2,
  },
  closeButton: {
    color: 'neutral.main',
  },
}

export default styles
